import './App.css';
import Layout from 'antd/lib/layout'
import FloatButton from 'antd/lib/float-button'
import {WhatsAppOutlined} from '@ant-design/icons'
//import BannerHeader from 'svg-react-loader?name=Banner!./assets/BannerHeader.svg'

//import B2 from './assets/B2.svg'
//Pages
import Header from './Pages/Header'
import Footer from './Pages/Footer'
import Content from './Pages/Content'

function App() {
  return (
    <div className="App">
      <Layout>
        <Layout.Header style={{height:'auto',backgroundImage:"url('img/BannerHeader.svg')",backgroundSize:'cover'}}>
          <Header/>
        </Layout.Header>
        <Layout.Content>
          <Content/>
        </Layout.Content>
        <Layout.Footer className='bg-c1'>
          <Footer/>
        </Layout.Footer>
        <FloatButton.Group>
          <FloatButton.BackTop />
          <FloatButton icon={<WhatsAppOutlined/>} target="_blank" href="https://wa.me/50584905650?text=Hola, quero saber mas informacion de como hacer mis pedidos, vengo de la web de Tuani's Express."/>
        </FloatButton.Group>
      </Layout>
    </div>
  );
}

export default App;
